import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { CustomTable } from "../../../../../../../../components"
import { ListDailyCutsProps } from "./types"
import { icons } from "../../../../../../../../utils/icons"
import { FiltersDrawer } from "../../../../../../../../components/filtersDrawer"




export const ListDailyCuts = (props: ListDailyCutsProps) => {

    const { t } = useTranslation()
    const styles = useStyles()

    return (
        <>
            <Box sx={styles.header}>
                <Typography variant="title_grey_big">{t('loogbook.titles.listOfDailyCuts')}</Typography>
                <Box>
                    {!!props.indexFilter.counter &&
                        <Tooltip title={t('ToolTips.clearFilters')}>
                            <IconButton
                                sx={(styles.clean, (props.indexFilter.counter || 0) > 0 ? null : styles.hide)}
                                onClick={() => {
                                    props.cleanFilter()
                                }}
                            >
                                {icons('clean')}
                            </IconButton>
                        </Tooltip>
                    }
                    <Button
                        className="gp1"
                        variant='contained'
                        disabled={props.all ? !props.all : !props.cutsSelected.length}
                        onClick={() => { props.setStep(1) }}
                    >
                        {t('general.resendReport')} {icons('send')}
                    </Button>
                </Box>
            </Box>

            <FiltersDrawer cleanFilter={props.cleanFilter} count={props.counter} right={-74} top={-73}>
                <Typography sx={styles.filter} >
                    Filtros
                </Typography>
                <Box sx={styles.section}>
                    {props.filter}
                </Box>
            </FiltersDrawer>

            <CustomTable
                serverSidePagination={{ page: props.indexFilter.paginationModel.page + 1, size: props.indexFilter.paginationModel.pageSize, totalPages: props.totalPages }}
                handleChange={(page: number, pageSize: number) => {
                    props.indexFilter.handlePagination({ page, pageSize })
                }}
                /* order={
                    filter?.query.sort && {
                        count: filter.query?.sort?.count,
                        key: filter.query?.sort?.field,
                        order: filter.query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    filter.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                loader={loading.table} */
                /* onClick={(e) => { handleSelects(e.checks ?? []) }} */
                defaultChecks={props.cutsSelected}
                loader={props.loading}
                name="Listado de cortes diarios"
                dontRefresh
                column={props.column}
                row={props.row ?? []}
                selected={-1}
            /* tableChecks */
            />
        </>
    )
}